import React from "react";
import pic from "../../../icons/geo.jpg";


class GeographyLeft extends React.Component {

    render() {
        return (
            <div className='word-wrap'>
                <h2>Site Location</h2>
                <div className='left-pane-pic'>
                    <img className="left-pane-pic" style={{marginTop:'50px', width:'180px', height:'180px'}} src={pic} alt="Logo" />
                </div>
                <div style={{marginTop:'30px'}}>Please provide information about site audience and organizational units</div>
            </div>
        );
    }
}
export default GeographyLeft







// WEBPACK FOOTER //
// ./src/components/CreateSite/Step3/GeographyLeft.js